/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Create_First_NameInputs */

const fr_guardian_create_first_name = /** @type {(inputs: Guardian_Create_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prénom`)
};

/**

* @param {Guardian_Create_First_NameInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_create_first_name = /** @type {((inputs?: Guardian_Create_First_NameInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Create_First_NameInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_create_first_name(inputs)
});